Customer.Dashboard ||= {}

class Customer.Dashboard.SelfAssignmentView extends Backbone.View
  template: JST["backbone/templates/customer/ticket/header/self_assignment"]
  events:
    'change #assigned_to': 'onAssignHandler'
    'click #assign-to-me': 'onAssignToMe'

  initialize: (usersGroups, model, users) ->
    @model = model
    @users = users
    @usersGroups = @_getUserGroups(usersGroups)
    @selectedOption = {attributes: {}}

  render: =>
    @$el.html(@template(
      model: @model.asJson(),
      current_user: Keepcon.current_user,
      current_user_is_assignable: @currentUserIsAssignable()
    ))
    @$el.find('#assigned_to').chosen(width: '190px', include_group_label_in_selected: true)
    @

  onAssignHandler: (event) =>
    $selectedOption = $(event.currentTarget).find(':selected')
    @onAssign($selectedOption)

  onAssign: (selectedOption) =>
    userId = selectedOption.data('userId')
    groupId = selectedOption.data('groupId')
    selectedOptionText = selectedOption[0].text
    attributes = assigned_to_id: userId, users_group_id: groupId
    @selectedOption = {
      userId: userId
      groupId: groupId
      assignedToName: selectedOptionText
      attributes: attributes
    } # this is needed for external use
    reRender = true
    @trigger('assignmentChange', userId, groupId, selectedOptionText, reRender)

  currentUserIsAssignable: ->
    isInGroup = _.some(@usersGroups, (group) =>
      _.some(group[1], (user) =>
        user.id == Keepcon.current_user.id
      )
    )
    isInGroup && @model.get('can_self_assign_closed_tickets')

  _getUserGroups: (usersGroups) ->
    ret = []
    for g in usersGroups
      ret.push([g, @_getUsersIn(g)]) if g.show_in_customer
    return ret

  _getUsersIn: (group) ->
    ret = []
    _.each(@users, (u) -> ret.push(u) if _.contains(group.user_ids, u.id))
    ret

  onAssignToMe: (event) ->
    selectedOptionText = Keepcon.current_user.first_name + ' ' + Keepcon.current_user.last_name
    @insertUserOption(Keepcon.current_user)
    $('#assigned_to').val(Keepcon.current_user.id)
    $('#assigned_to').trigger("chosen:updated")
    selectedOption = $('#assigned_to').find(':selected')
    @onAssign(selectedOption)

  insertUserOption: (user) ->
    users = @$el.find('#assigned_to').children('option').map( (i, e) =>
      return e.value || e.innerText
    ).get()
    unless _.contains(users, String(user.id))
      $('#assigned_to').append(
          "<option data-group-id='' data-user-id='" + user.id + "' value='" + user.id + "'>" + user.first_name + ' ' + user.last_name + "</option>"
      )
